import { combineReducers } from 'redux';

import globalReducer from '@ts/core/reducers';

import homePage from '@ts/containers/HomePage/reducer';
import storiesPage from '@ts/containers/StoriesPage/reducer';
import blogsPage from '@ts/containers/BlogsPage/reducer';
import activityPage from '@ts/containers/ActivityPage/reducer';
import activityReviewsPage from '@ts/containers/ActivityReviewsPage/reducer';
import activityReviewPage from '@ts/containers/ActivityReviewPage/reducer';
import attractionsPage from '@ts/containers/AttractionsPage/reducer';
import blogPostPage from '@ts/containers/BlogPostPage/reducer';
import blogsDestinationPage from '@ts/containers/BlogsDestinationPage/reducer';
import cartPage from '@ts/containers/CartPage/reducer';
import checkoutPage from '@ts/containers/CheckoutPage/reducer';
import contentPage from '@ts/containers/ContentPage/reducer';
import destinationPage from '@ts/containers/DestinationPage/reducer';
import orderPage from '@ts/containers/OrderPage/reducer';
import storiesDestinationPage from '@ts/containers/StoriesDestinationPage/reducer';
import storyPage from '@ts/containers/StoryPage/reducer';
import wishListPage from '@ts/containers/WishListPage/reducer';
import partnersPage from '@ts/containers/PartnersPage/reducer';
import partnersDestinationPage from '@ts/containers/PartnersDestinationPage/reducer';
import partnerPage from '@ts/containers/PartnerPage/reducer';
import itineraryPage from '@ts/containers/ItineraryPage/reducer';

const createRootReducer = () =>
    combineReducers({
        global: globalReducer,
        homePage,
        storiesPage,
        blogsPage,
        activityPage,
        activityReviewsPage,
        activityReviewPage,
        attractionsPage,
        blogPostPage,
        blogsDestinationPage,
        cartPage,
        checkoutPage,
        contentPage,
        destinationPage,
        orderPage,
        storiesDestinationPage,
        storyPage,
        wishListPage,
        partnersPage,
        partnersDestinationPage,
        partnerPage,
        itineraryPage,
    });

export default createRootReducer;
